var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    viewBox: "0 0 295 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    width: 70,
    height: 295,
    fill: "#D6ECFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 183,
    width: 70,
    height: 295,
    transform: "rotate(-90 0 183)",
    fill: "#D6ECFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7f41c26a34c78170adf7c668709a2d79.svg";
export { ForwardRef as ReactComponent };